import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart, Clock } from "lucide-react";
import { toast } from "sonner";
import { api, euro } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Gallery() {
  const [looks, setLooks] = useState([]);
  const { user } = useAuth();
  const nav = useNavigate();
  useEffect(() => { api.get("/gallery").then((r) => setLooks(r.data)).catch(() => {}); }, []);

  const save = async (id) => {
    if (!user) { toast.error("Accedi per salvare i look nel tuo KIMA ID"); nav("/accedi"); return; }
    try { await api.post("/my/save-look", { look_id: id }); toast.success("Salvato nel tuo KIMA ID"); }
    catch { toast.error("Errore nel salvataggio"); }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <span className="kima-overline text-burgundy">Ispirazione</span>
      <h1 className="font-serif text-5xl md:text-6xl text-espresso mt-3 mb-12">Galleria prenotabile</h1>
      <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
        {looks.map((l) => (
          <div key={l.id} className="break-inside-avoid border border-espresso/10 bg-offwhite rounded-sm overflow-hidden">
            <div className="hover-zoom relative">
              <img src={l.image} alt={l.title} className="w-full object-cover" />
              <button onClick={() => save(l.id)} data-testid={`save-look-${l.id}`} className="absolute top-3 right-3 bg-offwhite/90 p-2 rounded-full hover:bg-burgundy hover:text-ivory transition-colors"><Heart size={16} /></button>
            </div>
            <div className="p-4">
              <h3 className="font-serif text-xl text-espresso">{l.title}</h3>
              <div className="flex items-center gap-3 text-xs text-espresso/60 mt-2">
                <span className="flex items-center gap-1"><Clock size={12} /> {l.duration_min}min</span>
                <span>{euro(l.price)}</span>
                <span>{l.art_level}</span>
              </div>
              <button onClick={() => nav(l.service_id ? `/prenota?service=${l.service_id}&look=${l.id}` : `/prenota?look=${l.id}`)} data-testid={`book-look-${l.id}`} className="mt-3 w-full bg-espresso text-ivory py-2 rounded-sm text-sm hover:bg-burgundy transition-colors">Prenota questo look</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
